export default __webpack_public_path__ + "static/1832-d4f921b220a98e5d41aec0ba0dd78d6a.gif";